<template>
  <div id="application">
    <router-view />
  </div>
</template>
<script>
import "../static/plugins/bootstrap-v3.4.1/bootstrap.css";
import "../static/plugins/normalize-v8.0.1/normalize.css";
import "jquery/dist/jquery.min.js";
import "../static/plugins/bootstrap-v3.4.1/bootstrap.min.js";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "App",
  data() {
    return {
      curViewName: "PhotoSir"
    };
  },
  components: {
    Header,
    Footer
  },
  methods: {
    changeCurViewName(name) {
      this.curViewName = name;
      // 调用子视图函数
      this.$refs.header.onClickItemListener(name);
    }
  },
  created(){}
};
</script>

<style>
#application {
  width: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>



// WEBPACK FOOTER //
// src/App.vue